import { Worker, array_remove } from "../util";
import angular from "angular";
import moment from "moment";
import { isNull } from "util";
import Translate from "../Translate";
import Toastr from "../util/Toastr";

export default class ForecastDataCtrl {
  static $inject = ["ForecastDataService", "$state"];
  constructor(ForecastDataService, $state) {

    let that = this;
    // defaults
    this.data = {
      commodity: null,
      requiredOPM: null,

      selectedOPM: {},
      selectedOPM_ID: null,
      selectedDate: {
        index: moment().format('M') + moment().format('YYYY'),
        month: moment().format('M').toString(),
        year: moment().format('YYYY').toString(),
        date: moment().format()
      },
      timeline: null,

      table: null,
      // lang: 'cs',
      urlParams: $state.router.urlService.search(),
      // updateInProgress: false,
      canSaveData: false,
      canSendData: false,
      // error: {
      //   error: false,
      //   message: ''
      // }
    };

    this.import = {
      fileToImport: null,
      // error: {
      //   error: false,
      //   message: ''
      // },
      // inProgress: false
    }
    moment.locale(Translate.getMomentLanguageCode());

    this.ForecastDataService = ForecastDataService;
    this.createTimeline();

    if (this.data.urlParams.type && this.data.urlParams.opm) {
      this.data.commodity = this.data.urlParams.type;
      this.updateRequiredOPM(this.data.urlParams.opm);
    }
    // this.ForecastDataService.getMonthCalendar(
    //     this.data.selectedOPM,
    //     this.data.selectedDate.month,
    //     this.data.selectedDate.year
    //   ).then(data => {
    //     that.data.table = data;
    // });

    // this.requiredOPM = this.ForecastDataService.getOPM();
  }

  getDateFormat() {
    return Translate.getMomentLanguageCode() == 'en' ? 'MM/DD/YYYY' : 'DD.MM.YYYY' ;
  }
  
  getLocaleCode() {
    return Translate.getMomentLanguageCode() == 'en' ? 'en_US' : 'cs_CZ' ;
  }

  updateRequiredOPM(ean) {
    let that = this;

    Toastr.progress();
    // reset
    this.data.selectedOPM = {};
    this.data.selectedOPM_ID = null;
    this.data.table = null;
    this.data.canSaveData = false;

    that.data.requiredOPM = this.ForecastDataService.getOPM(
      this.data.commodity
    ).then(data => {
      that.data.requiredOPM = data;
      Toastr.clear();
      if(data.length === 1) {
        that.selectOpm(data[0]);
        that.data.selectedOPM_ID = item.id.toString();
        that.data.selectedOPM = item;
      } else {
        if (typeof ean != 'undefined') {
          data.forEach(function (item, i) {
            if (item.ean == ean) {
              that.data.selectedOPM_ID = item.id.toString();
              that.data.selectedOPM = item;
              that.updateTable();
              that.updateName();
              this.canSaveData();
              return;
            }
          });
        }
      }
    });

  }

  selectOpm(x) {
    Toastr.progress();
    // update data
    this.data.selectedOPM_ID = x.id.toString();
    this.data.selectedOPM = x;

    // update ui
    this.updateTable();
    this.updateName();
    // this.resetErrors();
    Toastr.clear();
  }

  updateTable() {

    Toastr.progress();

    if(!this.data.commodity) {
      Toastr.notify(Translate.trans('Pole "Komodita" musí být vyplněno'), "danger");
      return false;
    }

    if(!this.data.selectedOPM_ID) {
      Toastr.notify(Translate.trans('Pole "Seznam požadovaných OPM" musí být vyplněno'), "danger");
      return false;
    }

    let that = this;
    this.ForecastDataService.getMonthCalendar(
      this.data.selectedOPM_ID,
      this.data.selectedDate.date,
      this.data.commodity
    ).then(data => {
      that.data.table = that.formatNumberInData(data, true);
      this.canSaveData();
      Toastr.clear();
    });
  }

  updateName() {
    let that = this;
    this.data.requiredOPM.forEach(item => {
      if (item.id == that.data.selectedOPM_ID) { that.data.selectedOPM = item; return; }
    });
  }

  dayType(isWeekend, isHoliday) {
    var dayType = 'pracovní den';
    if (isWeekend) dayType = 'víkend';
    if (isHoliday) dayType = 'den pracovního klidu';
    return Translate.trans(dayType);
  }

  sumMWh() {
    var sum = 0;
    let that = this;
    if (this.data.table != null) {
      this.data.table.forEach(row => {
        sum += that.formatNumber(row.monthForecast);
      });
    }

    return this.formatNumber(sum, true);
  }

  saveMonthData() {
    Toastr.progress();
    let that = this;
    var msg = null;
    //return true;
    if (!this.data.updateInProgress) {
      // this.data.updateInProgress = true;
      this.ForecastDataService.saveMonthCalendar(
        this.data.selectedOPM_ID,
        this.data.selectedDate.date,
        this.data.commodity,
        this.formatNumberInData(this.data.table)
      ).then(result => {
        if (!result.error) {
          that.data.table = that.formatNumberInData(result.data, true);
          Toastr.notify(Translate.trans("Uložené"), "success");
        } else {
          Toastr.clear();

          msg = Translate.trans(result.message);
          if(typeof result.replacment !== 'undefined') { msg = msg.replace(':replacment:', result.replacment); }
          Toastr.notify(msg, "danger");
          // that.data.error = result
        }
        this.canSaveData();
        // that.data.updateInProgress = false;
      });
    }
  }

  sendActualData() {
    this.saveMonthData();
    Toastr.progress();
    let that = this;
    var msg = null;
    if (!this.data.updateInProgress) {
      // this.data.updateInProgress = true;
      this.ForecastDataService.sendActualData(
        this.data.selectedOPM_ID,
        this.data.selectedDate.date,
        this.data.commodity,
        this.getLocaleCode()
      ).then(result => {
        if (!result.error) {
          Toastr.notify(Translate.trans("Forecast byl úspešne odeslán dodávateli."), "success");
        } else {
          Toastr.clear();

          msg = Translate.trans(result.message);
          if(typeof result.replacment !== 'undefined') { msg = msg.replace(':replacment:', result.replacment); }
          Toastr.notify(msg, "danger");
        }
      });
    }
  }


  formatMonthForecastValue(data) {
    data.monthForecast = this.formatNumber(data.monthForecast, true);
  }

  formatWeekUpdateValue(data) {
    data.weekUpdate = this.formatNumber(data.weekUpdate, true);
  }

  formatNumber(num, forView) {

    if (isNull(num)) { return num; }

    if (typeof forView == 'undefined') { forView = false }

    num = num.toString()
      .replace(/[^0-9]/g, '');

    if (!forView) { return parseInt(num); }
    return num.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  calculateDiff(x, y, forView) {
    x = this.formatNumber(x); // odstránime čiarky 
    y = this.formatNumber(y); // odstránime čiarky 

    let diff = (x == null || y == null) ? 0 : (x - y);

    return this.formatNumber(diff, forView); // odpočitame a sformatujeme
  }

  formatNumberInData(data, forView) {
    let that = this;

    data.forEach(row => {
      row.monthForecast = that.formatNumber(row.monthForecast, forView);
      row.weekUpdate = that.formatNumber(row.weekUpdate, forView);
    });

    return data;
  }

  copyMonthForecastDataToWeekUpdate() {
    Toastr.progress();
    let that = this;

    this.data.table.forEach(row => {
      row.weekUpdate = row.monthForecast;
    });

    Toastr.clear();
  }

  createTimeline() {

    var config = {
      start: 0,
      beforeMonths: 13,
      end: 25
    };
    var date = moment();
    var output = [];

    date.subtract(config.beforeMonths, 'M');

    for (var index = config.start; index < config.end; index++) // moment vracia 1-12 preto index < 13
    {
      date.add(1, 'M');

      output[date.format('MMMM') + ', ' + date.format('YYYY')] = {
        index: date.format('M') + date.format('YYYY'),
        month: date.format('M'),
        year: date.format('YYYY'),
        date: date.format()
      }
    }

    this.data.timeline = output;
    //return output;
  }

  // validačne veci
  canEditMonthForecast(date, isLocked) {
    var firstDayOfMonth = moment().add(1, 'month').startOf('month');
    var checkDate = moment(date);

    return !(firstDayOfMonth.isAfter(checkDate, 'month') || isLocked);
  }

  canEditWeekUpdate(date, isLocked) {
    var lastDayOfMonth = moment().endOf('month');
    var checkDate = moment(date); // M
    var isAfter = lastDayOfMonth.isAfter(checkDate, 'month'); // x >= y
    var isBefore = lastDayOfMonth.isBefore(checkDate, 'month'); // x <= y
    return !((isAfter || isBefore) || isLocked);
  }
  
  canEditMonthNote(date, isLocked) {
    var firstDayOfMonth = moment().endOf('month');
    var checkDate = moment(date);
    return firstDayOfMonth.isAfter(checkDate, 'month') || isLocked;
  }

  canSaveData() {
    let that = this;
    var canSaveData = true;
    var canSendData = true;
    var isAtLeastOneWeekUnlocked = false;
    this.data.table.forEach(row => {

      if (that.canEditMonthForecast(row.date, row.isMonthForecastDateLocked)) {
        if (row.monthForecast == null || row.monthForecast === '') {
          canSaveData = false;
          canSendData = false;
          return;
        }
      }

      if(row.isWeekUpdateDateLocked) {
        isAtLeastOneWeekUnlocked = true;
      }
      
      if(that.canEditWeekUpdate(row.date, row.isWeekUpdateDateLocked)) {
        if (row.weekUpdate == null || row.weekUpdate === '') {
          Toastr.notify(Translate.trans("Nemáte vyplňené všechny položky."), "warning");
          //canSaveData = false;
          canSendData = false;
          return;
        }
      }
    });

    if(!isAtLeastOneWeekUnlocked) {
      canSendData = false;
    }

    this.data.canSaveData = canSaveData;
    this.data.canSendData = canSendData;
  }

  copyMonthForecastValueToWeek(data) {
    data.weekUpdate = data.monthForecast;
  }

  // import
  onFile($file) {
    this.import.fileToImport = $file;
    this.startImport();
  }

  startImport() {
    Toastr.progress();
    let that = this;
    //this.import.inProgress = true;
    this.ForecastDataService.importFile(
      this.import.fileToImport,
      this.data.selectedOPM_ID,
      this.data.selectedDate.date,
      this.data.commodity
    ).then(result => {
      //that.import.inProgress = false;
      //that.import.error = result;

      if (!result.error) {
        that.updateTable();
        Toastr.notify(Translate.trans("Uložené"), "success");
      }else{
        Toastr.clear();
        var msg = Translate.trans(result.message);
        if(typeof result.replacment !== 'undefined') { msg = msg.replace(':replacment:', result.replacment); }
        Toastr.notify(msg, "danger");
      }
      this.canSaveData();
      // reset input
      document.getElementById('file-reset').value = "";
    })
  }

  getEmptyXls()
  {
    this.ForecastDataService.getEmptyXls(
        this.data.selectedDate.date,
        this.data.selectedOPM.firstDay ? this.data.selectedOPM.firstDay : null,
        this.getLocaleCode()
    );
  }
}



// WEBPACK FOOTER //
// ./src/ForecastData/ForecastDataCtrl.js